import { render, staticRenderFns } from "./CompanyClient.vue?vue&type=template&id=709c413f&scoped=true"
import script from "./CompanyClient.vue?vue&type=script&lang=js"
export * from "./CompanyClient.vue?vue&type=script&lang=js"
import style0 from "./CompanyClient.vue?vue&type=style&index=0&id=709c413f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c413f",
  null
  
)

export default component.exports